// CompanyTimeline.jsx
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './about-timeline.css'

const CompanyTimeline = () => {
  const [selectedYear, setSelectedYear] = useState('2008');
  const [imageLoading, setImageLoading] = useState(false);
  const [preloadedImages, setPreloadedImages] = useState(new Set());

  const timelineData = {
    '2008': {
      title: "KLM Polymers",
      description: "KLM Polymers is Manufacturers & Supplier of PP, HM- HDPE, LD-LLDPE, Treated Lay Flat tubes, Sheets, PP, HM –HDPE Bags.",
      image: "/assets/hdpe-roll-1000x1000.png",
      isActive: true
    },
    '2014': {
      title: "KLM Flexi Pack Pvt Ltd",
      description: "KLM Flexi Pack Pvt Ltd. specializes in innovative agricultural solutions, particularly through its high-performance Mulch Films that can increase crop yields. These specialized films, ideal for crops like tomatoes and chilies etc.., help create optimal growing conditions by regulating temperature, moisture, and protecting plants from weeds. With a focus on improving agricultural productivity, KLM Flexi Pack offers top-quality products designed to support farmers in achieving better, more efficient harvests. Our mission is to provide easy access to these advanced solutions, enhancing both the quality and quantity of crops while saving time and resources.",
      image: "/assets/Mulching Film.jpg",
      isActive: false
    },
    '2023': {
      title: "KLM Packaging Industries",
      description: "KLM Packaging Industries is Manufacturer of Paper bags, Courier Bags, Packaging Products Printed and Plain. We are specialist in design and manufacturing eco-friendly products like Brown/White Paper Bags, and SOS Bags. We are equipped with a fully automatic bag making and printing machines, offset machine etc. Not only that, but we deliver products of the best quality, price, service and reliability. KLM believes in customer satisfaction and leaves no stone unturned to give the best services in the industry.",
      image: "/assets/promotional-bags-about-page.png",
      isActive: false
    }
  };

  // Preload all images when component mounts
  useEffect(() => {
    const preloadImages = () => {
      Object.entries(timelineData).forEach(([year, data]) => {
        const img = new Image();
        img.onload = () => {
          setPreloadedImages(prev => new Set([...prev, data.image]));
        };
        img.onerror = () => {
          console.warn(`Failed to preload image: ${data.image}`);
        };
        img.src = data.image;
      });
    };

    preloadImages();
  }, []);

  const handleYearClick = (year) => {
    // Show loading only if image isn't preloaded yet
    if (!preloadedImages.has(timelineData[year].image)) {
      setImageLoading(true);
    }
    setSelectedYear(year);
  };

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  return (
    <div style={{ marginTop: '100px' }}>
      {/* Centered Header Section */}
      <div className="container-fluid mb-5">
        <div className="row justify-content-center">
          <div className="col-12 text-center">
            <div className="my-5 py-4">
              <img  
                width={'80px'} 
                height={'60px'}
                src="/assets/icons/eco-bag_2293318.svg"
                alt="Organic & Eco Solutions icon" 
                className="img-fluid"
              />
            </div>
            <h1 className='main-heading'>Welcome To KLM Group</h1>
            <div className="border-bottom border-danger mx-auto mt-3" style={{ width: '100px' }}></div>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="container-fluid">
        <div className="row">
          {/* Left side with dynamic image */}
          <div className="col-md-6 p-0">
            <div className="d-flex justify-content-center align-items-center h-100 py-5 position-relative">
              {/* Loading spinner - only show if image is actually loading */}
              {imageLoading && (
                <div className="position-absolute">
                  <div className="spinner-border text-danger" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
              
              <img 
                src={timelineData[selectedYear].image}
                alt={timelineData[selectedYear].title}
                className="img-fluid"
                style={{ 
                  maxWidth: '80%',
                  opacity: imageLoading ? 0.3 : 1,
                  transition: 'opacity 0.3s ease'
                }}
                onLoad={handleImageLoad}
              />
            </div>
          </div>

          {/* Right side with timeline - KEEPING YOUR ORIGINAL LAYOUT */}
          <div className="col-md-6 py-5">
            <div className="container">
              {/* Timeline Container */}
              <div className="position-relative">
                {/* Vertical line - SINGLE LINE FOR ALL CIRCLES */}
                <div className="position-absolute h-100" 
                     style={{
                       width: '1px', 
                       backgroundColor: '#dc3545',
                       left: '100px',
                       top: '0'
                     }}>
                </div>

                {/* Timeline items - EXACT SAME AS YOUR ORIGINAL */}
                <div className="timeline-items">
                  {Object.entries(timelineData).map(([year, data]) => (
                    <div key={year} className="d-flex mb-5 position-relative">
                      <div 
                        className={`rounded-circle border border-2 d-flex align-items-center justify-content-center bg-white ${
                          selectedYear === year ? 'text-danger border-danger' : ''
                        }`}
                        style={{
                          width: '200px', 
                          height: '200px',
                          zIndex: '2',
                          cursor: 'pointer',
                          transition: 'all 0.3s ease',
                          fontSize: '2rem'
                        }}
                        onClick={() => handleYearClick(year)}
                      >
                        <span className={selectedYear === year ? 'text-danger' : ''}>
                          {year}
                        </span>
                      </div>

                      {/* Content section */}
                      {selectedYear === year && (
                        <div className="ms-4 text-center" style={{ flex: 1 }}>
                          <h6 className="timeline-title text-danger mb-3" style={{ letterSpacing: '1px' }}>
                            {data.title}
                          </h6>
                          <div className="text-muted">
                            <p className="mb-4" style={{ lineHeight: '1.8' }}>
                              {data.description}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Hidden preload images - this helps with caching */}
      <div style={{ display: 'none' }}>
        {Object.entries(timelineData).map(([year, data]) => (
          <img key={year} src={data.image} alt="" />
        ))}
      </div>
    </div>
  );
};

export default CompanyTimeline;